export const buildAreeDaAbbinare = (mapDati) => {

    // costruzione opzioni Aree (730, IMU, VARIE .....)
    const optionsMacroAree = []
    Object.keys(mapDati).forEach((macroArea) => {
        if (macroArea !== "area_da_abbinare") {
            const option = {}
            option.label = macroArea
            option.value = macroArea
            optionsMacroAree.push(option)
        }
    })

    // costruzione list elementi aree ancora da abbinare
    const list = []
    mapDati.area_da_abbinare.forEach(area => {
        area.ricavi.forEach((element) => {
            const codice_ricavo = element.codiceRicavo
            const descrizioneCR = element.descrizioneCodiceRicavo
            const areaDaAbbinare = {}
            areaDaAbbinare.name = descrizioneCR
            areaDaAbbinare.codice = codice_ricavo
            areaDaAbbinare.value = optionsMacroAree
            list.push(areaDaAbbinare)
        })
    });
    return list
}

export const buildSottoAreeDaAbbinare = (mapDati) => {

    const optionsMacroAree = []
    Object.keys(mapDati).forEach((macroArea) => {
        if (macroArea !== "area_da_abbinare") {
            const option = {}
            option.label = macroArea
            option.value = macroArea
            optionsMacroAree.push(option)
        }
    })


    const aree = []
    Object.keys(mapDati).forEach((macroArea) => {
        if (macroArea !== "area_da_abbinare") {
            const area = {}
            area.name = macroArea
            const associati = {}
            const listSottoAreeDaAssociare = []
            const listAreePersonalizzati = []
            const sottoAreaAssociati = {}
            mapDati[macroArea].forEach((sottoArea) => {
                if (sottoArea.ricavi.length > 0) {
                    sottoArea.ricavi.forEach((e) => {
                        const codice_ricavo = e.codiceRicavo
                        const descrizioneCR = e.descrizioneCodiceRicavo
                        const areaAbbinati = {}
                        areaAbbinati.name = descrizioneCR
                        areaAbbinati.codice = codice_ricavo
                        areaAbbinati.selected = { label: macroArea, value: macroArea }
                        associati[codice_ricavo] = areaAbbinati
                    })
                }
            })
            mapDati[macroArea].forEach((sotto) => {
                if (sotto.nome !== "sottoarea_da_abbinare") {
                    const specificaArea = {}
                    specificaArea.label = sotto.nome
                    specificaArea.value = sotto.nome
                    listAreePersonalizzati.push(specificaArea)
                    if (sotto.ricavi.length > 0) {
                        const listSottoAreeAssociati = []
                        sotto.ricavi.forEach((sottoArea) => {
                            sottoArea.tariffe.forEach((tariffario) => {
                                const sottoAreaAssociata = {}
                                var desTariffa = tariffario.descrizioneTariffa
                                if (tariffario.descrizioneTariffa === "") {
                                    desTariffa = "DESCRIZIONE VUOTA (" + sottoArea.descrizioneCodiceRicavo + ")"
                                }
                                sottoAreaAssociata.descrizione = desTariffa
                                sottoAreaAssociata.selected = { label: sotto.nome, value: sotto.nome }
                                listSottoAreeAssociati.push(sottoAreaAssociata)
                            })
                        })
                        sottoAreaAssociati[sotto.nome] = listSottoAreeAssociati
                    }

                }
                if (sotto.nome === "sottoarea_da_abbinare" && sotto.ricavi.length > 0) {
                    sotto.ricavi.forEach((sottoArea) => {
                        const codiceRC = sottoArea.codiceRicavo
                        sottoArea.tariffe.forEach((tariffario) => {
                            const sottoAreaDaAssociare = {}
                            sottoAreaDaAssociare.codiceRt = tariffario.codiceTariffa
                            var desTariffa = tariffario.descrizioneTariffa
                            if (tariffario.descrizioneTariffa === "") {
                                desTariffa = "DESCRIZIONE VUOTA (" + sottoArea.descrizioneCodiceRicavo + ")"
                            }
                            sottoAreaDaAssociare.descrizione = desTariffa
                            sottoAreaDaAssociare.options = listAreePersonalizzati
                            sottoAreaDaAssociare.codiceRc = codiceRC
                            listSottoAreeDaAssociare.push(sottoAreaDaAssociare)
                        })
                    })

                }
            })

            area.associati = associati
            area.list_sottoaree_da_associare = listSottoAreeDaAssociare
            area.sottoaree_associati = sottoAreaAssociati
            area.show = false
            if (
                Object.keys(associati).length > 0 ||
                listSottoAreeDaAssociare.length > 0 ||
                Object.keys(sottoAreaAssociati).length > 0) {
                area.show = true
            }
            aree.push(area)
        }
    })
    return aree
}
